
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: inline-block
}

.rate {

    display: flex
}

.star {

    color: var(--neutral-gray-4)
}

.star--active {

    color: var(--tertiary-orange)
}

.star-wrapper {

    position: relative
}

.star-wrapper .star--active {

    position: absolute;

    overflow: hidden
}
`;